import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const HowItWorks: React.FC = () => {
  return (
    <Container className="text-center" id="works">
      <div className="mb-3">
        <h1>How it Works</h1>
        <h4 className="text-whatshot mb20">For Organizers</h4>
        <Row className="mx-auto mb60">
          <Col lg={3} xs={6} className="mb-3">
            <div>
              <img src="/assets/images/WhatsDesign (1)/Frame 1000011383.png" width="120" height="120" alt="Post Job" />
            </div>
            <span className="fs-4 fw-semibold">
              Post a Job. <br />
              No Cost.
            </span>
          </Col>
          <Col lg={3} xs={6} className="mb-3">
            <div>
              <img src="/assets/images/WhatsDesign (1)/Frame 1000011383-1.png" width="120" height="120" alt="Receive Proposals" />
            </div>
            <span className="fs-4 fw-semibold">
              Receive <br />
              proposals.
            </span>
          </Col>
          <Col lg={3} xs={6} className="mb-3">
            <div>
              <img src="/assets/images/WhatsDesign (1)/Frame 1000011383-2.png" width="120" height="120" alt="Choose Favorite" />
            </div>
            <span className="fs-4 fw-semibold">
              Choose Your<br />
              Favorite.
            </span>
          </Col>
          <Col lg={3} xs={6} className="mb-3">
            <div>
              <img src="/assets/images/WhatsDesign (1)/Frame 1000011383-3.png" width="120" height="120" alt="Collaborate & Pay" />
            </div>
            <span className="fs-4 fw-semibold">
              Collaborate<br />
              & Pay.
            </span>
          </Col>
        </Row>
        <h4 className="text-whatshot mb20">For Vendors & Freelancers</h4>
        <Row>
          <Col lg={3} xs={6} className="mb-3">
            <div>
              <img src="/assets/images/WhatsDesign (2)/Frame 1000011383.png" width="120" height="120" alt="Create Profile" />
            </div>
            <span className="fs-4 fw-semibold">
              Create Profile.<br />
              Free to join.
            </span>
          </Col>
          <Col lg={3} xs={6} className="mb-3">
            <div>
              <img src="/assets/images/WhatsDesign (2)/Frame 1000011383-1.png" width="120" height="120" alt="Browse Jobs" />
            </div>
            <span className="fs-4 fw-semibold">
              Browse<br />
              jobs.
            </span>
          </Col>
          <Col lg={3} xs={6} className="mb-3">
            <div>
              <img src="/assets/images/WhatsDesign (2)/Frame 1000011383-2.png" width="120" height="120" alt="Submit Proposals" />
            </div>
            <span className="fs-4 fw-semibold">
              Submit<br />
              proposals.
            </span>
          </Col>
          <Col lg={3} xs={6} className="mb-3">
            <div>
              <img src="/assets/images/WhatsDesign (2)/Frame 1000011383-3.png" width="120" height="120" alt="Get Hired" />
            </div>
            <span className="fs-4 fw-semibold">
              Get<br />
              Hired!
            </span>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default HowItWorks;
